import { Injectable } from '@angular/core';
import { CommonHttpService } from '@app-core/services/common-http/common-http.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FaceIdResolverResolver {
  constructor(private commonHttpService: CommonHttpService) {}

  public resolve(): Observable<boolean> {
    return this.commonHttpService.faceIdEnabled().pipe(catchError(() => of(false)));
  }
}
